<template>
    <div>
        <section-header />
        
  <div class="sidebar-page-container">
          <div class="auto-container">
              <div class="row clearfix">

                  <!--Content Side / Services Single-->
                  <div class="content-side pull-right col-lg-8 col-md-8 col-sm-12 col-xs-12">
                      <div class="services-single">
                          <div class="inner-box">

                              <!--Upper Box-->
                              <div class="upper-box" v-if="currentShowBlock === 'tailor-made-solutions'">
                                  <div class="row clearfix">
                                      <div class="column col-md-6 col-sm-6 col-xs-12">
                                          <h4 id="tailor-made-solutions">{{ $t('view.services-academy.title-1') }}</h4>
                                          <div class="upper-text">{{ $t('view.services-academy.text-1') }}
                                          </div>
                                          <ul class="list-style-three">
                                              <li>{{ $t('view.services-academy.list-a.item-1') }}</li>
                                              <li>{{ $t('view.services-academy.list-a.item-2') }}</li>
                                              <li>{{ $t('view.services-academy.list-a.item-3') }}</li>
                                          </ul>
                                      </div>
                                      <div class="column col-md-6 col-sm-6 col-xs-12">
                                          <div class="image">
                                              <img src="images/resource/bcom/service-academy-hands-check.jpg" alt="" />
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <!--Upper Box-->

                              <!--Upper Box-->
                              <div class="upper-box" v-if="currentShowBlock === 'budget-contracts-negotiation'">
                                  <div class="row clearfix">
                                      <div class="column col-md-6 col-sm-6 col-xs-12">
                                          <h4>{{ $t('view.services-academy.title-2') }}</h4>
                                          <div class="upper-text">{{ $t('view.services-academy.text-2') }}
                                          </div>
                                      </div>
                                      <div class="column col-md-6 col-sm-6 col-xs-12">
                                          <div class="image">
                                              <img src="images/resource/bcom/service-academy-hands-check.jpg" alt="" />
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <!--Upper Box-->

                              <!--Upper Box-->
                              <div class="upper-box" v-if="currentShowBlock === 'full-project-support'">
                                  <div class="row clearfix">
                                      <div class="column col-md-6 col-sm-6 col-xs-12">
                                          <h4>{{ $t('view.services-academy.title-3') }}</h4>
                                          <div class="upper-text">{{ $t('view.services-academy.text-3') }}
                                          </div>
                                      </div>
                                      <div class="column col-md-6 col-sm-6 col-xs-12">
                                          <div class="image">
                                              <img src="images/resource/bcom/service-academy-hands-check.jpg" alt="" />
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <!--Upper Box-->

                              <!--Upper Box-->
                              <div class="upper-box" v-if="currentShowBlock === 'our-experience'">
                                  <div class="row clearfix">
                                      <div class="column col-md-6 col-sm-6 col-xs-12">
                                          <h4>{{ $t('view.services-academy.title-4') }}</h4>
                                          <div class="upper-text">{{ $t('view.services-academy.text-4') }}
                                          </div>
                                      </div>
                                      <div class="column col-md-6 col-sm-6 col-xs-12">
                                          <div class="image">
                                              <img src="images/resource/bcom/service-academy-hands-check.jpg" alt="" />
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <!--Upper Box-->

                              <!--Upper Box-->
                              <div class="upper-box" v-if="currentShowBlock === 'our-commitment'">
                                  <div class="row clearfix">
                                      <div class="column col-md-6 col-sm-6 col-xs-12">
                                          <h4>{{ $t('view.services-academy.title-5') }}</h4>
                                          <div class="upper-text">{{ $t('view.services-academy.text-5') }}
                                          </div>
                                      </div>
                                      <div class="column col-md-6 col-sm-6 col-xs-12">
                                          <div class="image">
                                              <img src="images/resource/bcom/service-academy-hands-check.jpg" alt="" />
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <!--Upper Box-->

                              <!--Upper Box-->
                              <div class="upper-box" v-if="currentShowBlock === 'project-life-cycle'">
                                  <div class="row clearfix">
                                      <div class="column col-md-6 col-sm-6 col-xs-12">
                                          <h4>{{ $t('view.services-academy.title-6') }}</h4>
                                          <div class="text">{{ $t('view.services-academy.text-6') }}</div>
                                          <br><br>
                                          <div class="text">{{ $t('view.services-academy.text-7') }}</div>
                                          <br><br>

                                      </div>
                                      <div class="column col-md-6 col-sm-6 col-xs-12">
                                          <div class="image" v-if="currentShowBlock !== 'project-life-cycle'">
                                              <img src="images/resource/bcom/service-academy-hands-check.jpg" alt="" />
                                          </div>
                                          <h4>&nbsp;</h4>
                                          <div v-if="currentShowBlock === 'project-life-cycle'">
                                               <div class="text">{{ $t('view.services-academy.text-8') }}</div>
                                               <br><br>
                                                 <div class="text">{{ $t('view.services-academy.text-9') }}</div>
                                                 <br><br>
                                                 <div class="text">{{ $t('view.services-academy.text-10') }}</div>
                                                 <br><br>
                                                 <div class="text">{{ $t('view.services-academy.text-11') }}</div>
                                                 <br><br>
                                                 <div class="image" v-if="currentShowBlock === 'project-life-cycle'">
                                                    <img src="images/resource/bcom/service-academy-conference.jpg" alt="" />
                                                 </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <!--Upper Box-->

                              <!--Services Block Seven-->
                              <div class="row clearfix">
                              </div>
                              <br><br>
                          </div>
                      </div>
                  </div>

                  <!--Sidebar-->
                  <div class="sidebar-side pull-left col-lg-4 col-md-4 col-sm-12 col-xs-12">
                      <aside class="sidebar">

                          <!--Services Category-->
                          <div class="sidebar-widget services-category">
                              <ul class="services-list">
                                  <li :class="currentShowBlock === 'tailor-made-solutions'? 'active' : ''"><a v-on:click="showBlock('tailor-made-solutions')"><span class="icon flaticon-graph"></span>{{ $t('view.services-academy.title-1') }}</a></li>
                                  <li :class="currentShowBlock === 'budget-contracts-negotiation'? 'active' : ''"><a v-on:click="showBlock('budget-contracts-negotiation')"><span class="icon flaticon-donation"></span>{{ $t('view.services-academy.title-2') }}</a></li>
                                  <li :class="currentShowBlock === 'full-project-support'? 'active' : ''"><a v-on:click="showBlock('full-project-support')"><span class="icon flaticon-structure"></span>{{ $t('view.services-academy.title-3') }}</a></li>
                                  <li :class="currentShowBlock === 'our-experience'? 'active' : ''"><a v-on:click="showBlock('our-experience')"><span class="icon flaticon-medal-1"></span>{{ $t('view.services-academy.title-4') }}</a></li>
                                  <li :class="currentShowBlock === 'our-commitment'? 'active' : ''"><a v-on:click="showBlock('our-commitment')"><span class="icon flaticon-note-1"></span>{{ $t('view.services-academy.title-5') }}</a></li>
                                  <li :class="currentShowBlock === 'project-life-cycle'? 'active' : ''"><a v-on:click="showBlock('project-life-cycle')"><span class="icon flaticon-business-3"></span>{{ $t('view.services-academy.title-6') }}</a></li>
                              </ul>
                          </div>

                      </aside>
                  </div>

              </div>
          </div>
          <script type="application/javascript" defer src="js/script.js"></script>
      </div>

      </div>
</template>

<script>
import SectionHeader from '@/components/SectionHeader.vue';

export default {
  name: 'ServicesAcademy',
  components: {
    SectionHeader
  },
  data() {
    return {
      content: '',
      currentShowBlock: 'tailor-made-solutions',
    };
  },
  methods: {
    showBlock: function(id) {
        this.currentShowBlock = id;
    }
  },
  computed: {
   currentPa() {
        return this.$router.history.current.name;
      },
  },
  mounted() {

  }
};
</script>